var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',_vm._b({staticClass:"mini",style:(_vm.style),attrs:{"effect":_vm.effect,"disable-transitions":_vm.disableTransitions}},'el-tag',_vm.$attrs,false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }